import { getClient } from "services";

export async function searchSchools(searchTerm: string) {
  return await getClient("schoolsService").searchSchoolsList(searchTerm);
}

export async function fetchTeacherSchools() {
  return await getClient("schoolsService").fetchMyTeacherSchools();
}

export async function fetchTeacherClasses(schoolId: string) {
  return await getClient("schoolsService").getSchoolClassesTeacher(schoolId);
}

export async function joinSchoolClass(schoolId: string, classId: string) {
  return await getClient("schoolsService").joinSchoolClass({
    schoolId,
    classId
  });
}

export async function joinSchoolClasses(schoolId: string, classIds: string[]) {
  return await getClient("schoolsService").joinSchoolClasses({
    schoolId,
    classIds
  });
}

export async function inviteAllSchoolParents(schoolId: string) {
  return await getClient("schoolsService").inviteAllSchoolParents(schoolId);
}

export async function putMySchoolInfo(schoolId: string | undefined) {
  return await getClient("schoolsService").putMySchoolInfo({ schoolId });
}

export async function fetchMySchoolInfo() {
  return await getClient("schoolsService").fetchMySchoolInfo();
}
